import Joi from "joi-browser";
import useConfigureForm from "../../../../useConfigureForm";

export default useWebhookForm;

const webhookSchema = {
  webhookName: Joi.string().allow(null, ""),
  eventName: Joi.string().disallow("").required().label("event name"),
  endpointUrl: Joi.string().required().label("Webhook Url"),
  authRequired: Joi.boolean().label("Auth required"),
  authKey: Joi.string().allow(null, "").label("Auth Key"),
};

function getWebhookConfigureData(webhook) {
  return {
    webhookName: webhook?.webhookName ?? "",
    eventName: webhook?.eventName ?? "captureEvent",
    endpointUrl: webhook?.endpointUrl ?? "",
    authRequired: webhook?.authRequired ?? false,
    authKey: webhook?.authKey ?? "",
  };
}

function useWebhookForm(webhook) {
  const { formState, updateFormState, errors, validate } = useConfigureForm(
    () => getWebhookConfigureData(webhook),
    webhookSchema,
  );

  return {
    formState,
    updateFormState,
    errors,
    validate,
  };
}
